var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMark2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 11,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 5.5L4.64 9l8-8",
  stroke: "#000",
  strokeWidth: 2
})));
export { SvgMark2 as ReactComponent };